(function () {
  /* clock */
  function tick() {
    const el = document.getElementById('jca-clock');
    if (!el) return;
    const n = new Date(), p = v => String(v).padStart(2, '0');
    el.textContent = `${n.getFullYear()}.${p(n.getMonth()+1)}.${p(n.getDate())}  ${p(n.getHours())}:${p(n.getMinutes())}:${p(n.getSeconds())}`;
  }
  tick(); setInterval(tick, 1000);

  /* shared noise canvas */
  const W = 160, H = 160;
  const off = document.createElement('canvas');
  off.width = W; off.height = H;
  const oc = off.getContext('2d');
  const canvases = document.querySelectorAll('.jca-feed__noise');

  function sizeAll() {
    canvases.forEach(c => {
      const wrap = c.closest('.jca-feed__wrap');
      c.width = wrap.offsetWidth;
      c.height = wrap.offsetHeight;
    });
  }
  sizeAll();
  window.addEventListener('resize', sizeAll);

  let last = 0;
  function noise(ts) {
    if (ts - last > 50) {
      last = ts;
      const id = oc.createImageData(W, H), d = id.data;
      for (let i = 0; i < d.length; i += 4) {
        const v = Math.random() * 255 | 0;
        d[i] = d[i+1] = d[i+2] = v;
        d[i+3] = (Math.random() * 32 + 6) | 0;
      }
      oc.putImageData(id, 0, 0);
      canvases.forEach(c => {
        const ctx = c.getContext('2d');
        ctx.clearRect(0, 0, c.width, c.height);
        ctx.drawImage(off, 0, 0, c.width, c.height);
      });
    }
    requestAnimationFrame(noise);
  }
  requestAnimationFrame(noise);

  /* flicker */
  const imgs = document.querySelectorAll('.jca-feed__wrap img');
  function flicker() {
    if (!imgs.length) return;
    const img = imgs[Math.floor(Math.random() * imgs.length)];
    img.style.transition = 'none';
    img.style.filter = 'contrast(1.4) saturate(0) brightness(0.2)';
    setTimeout(() => {
      img.style.filter = '';
      setTimeout(flicker, Math.random() * 4000 + 1000);
    }, Math.random() * 100 + 30);
  }
  setTimeout(flicker, 2000);

  /* video hover: only ever decode one video at a time (Safari has a hard
     limit on concurrent hardware video decoder sessions; letting multiple
     feeds play/decode at once causes some to silently fail or freeze) */
  let activeVideo = null;
  document.querySelectorAll('.jca-feed').forEach(feed => {
    const video = feed.querySelector('.jca-feed__video');
    if (!video) return;
    video.muted = true;
    feed.addEventListener('mouseenter', () => {
      if (activeVideo && activeVideo !== video) {
        activeVideo.pause();
        activeVideo.currentTime = 0;
      }
      activeVideo = video;
      video.play().catch(() => {});
    });
    feed.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
      if (activeVideo === video) activeVideo = null;
    });
  });
})();
